import useWindowDimensions from '@hooks/useWindowDimensions'
import { HowItWorksFour } from '@public/static/vectorIllustrations/how-it-works-four'
import { HowItWorksOne } from '@public/static/vectorIllustrations/how-it-works-one'
import { HowItWorksThree } from '@public/static/vectorIllustrations/how-it-works-three'
import { HowItWorksTwo } from '@public/static/vectorIllustrations/how-it-works-two'
import {
  BenefitsForCreatorsHeader,
  CurveOne,
  CurveThree,
  CurveTwo,
  Gradient2,
  HowItWorksHeader,
  HowItWorksLineOne,
  HowItWorksText,
  HowItWorksTextWrapper,
  HowItWorksWrapper,
  LeftImageWrapper,
  RightImageWrapper,
  StepNumber,
  TextTwoWrapper,
} from '@styled_components/home/styled.components'
import { useTranslation } from 'react-i18next'

type Props = {
  isForBenefitsPage?: boolean
}

const HowItWorks = ({ isForBenefitsPage = false }: Props) => {
  const { width } = useWindowDimensions()
  const { t } = useTranslation(['landingPage'])
  return (
    <HowItWorksWrapper id="howitworks">
      <BenefitsForCreatorsHeader
        style={{
          margin: isForBenefitsPage ? 'auto' : '',
          width: 'max-content',
          marginBottom: (width || 0) < 731 ? -10 : isForBenefitsPage ? 60 : 80,
          marginTop: -10,
        }}
        className={
          isForBenefitsPage
            ? ''
            : '!font-[700] text-uguPurple sm:-ml-5 text-center'
        }
      >
        {t('howItWorks', { ns: 'landingPage' })}
      </BenefitsForCreatorsHeader>
      <HowItWorksLineOne
        style={{
          flexDirection: (width || 0) < 731 ? 'column-reverse' : 'row',
        }}
      >
        <CurveOne>
          <StepNumber>#1</StepNumber>
        </CurveOne>
        <HowItWorksTextWrapper>
          {(width || 0) < 731 && (
            <StepNumber
              style={{
                marginLeft: -35,
                fontSize: 20,
                position: 'absolute',
                width: 'max-content',
                height: 35,
              }}
            >
              #1
            </StepNumber>
          )}
          <HowItWorksHeader>
            {t('createYourCourse', { ns: 'landingPage' })}
          </HowItWorksHeader>
          <HowItWorksText>
            {t('createYourCourseDetail', { ns: 'landingPage' })}
          </HowItWorksText>
        </HowItWorksTextWrapper>
        <RightImageWrapper style={{ borderLeft: 0 }}>
          <Gradient2
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              margin: 'auto',
            }}
          ></Gradient2>
          <HowItWorksOne
            width={(width || 0) < 1561 ? '23vw' : '359'}
            right={(width || 0) < 1561 ? '10vw' : '100'}
            position={(width || 0) < 731 ? 'static' : 'absolute'}
          ></HowItWorksOne>
        </RightImageWrapper>
      </HowItWorksLineOne>
      <HowItWorksLineOne>
        <LeftImageWrapper>
          <Gradient2
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              margin: 'auto',
              opacity: 0.19,
            }}
          ></Gradient2>
          <HowItWorksTwo
            width={
              (width || 0) < 1561
                ? (width || 0) < 768
                  ? '212px'
                  : '23vw'
                : '365'
            }
            height={(width || 0) < 768 ? '228px' : '280px'}
            className="m-auto"
          />
        </LeftImageWrapper>
        <CurveTwo>
          <StepNumber
            style={{
              margin: 0,
              marginLeft: (width || 0) < 1561 ? '1.5vw' : 25,
            }}
          >
            #2
          </StepNumber>
        </CurveTwo>
        <TextTwoWrapper>
          {(width || 0) < 731 && (
            <StepNumber
              style={{
                marginLeft: -35,
                fontSize: 20,
                position: 'absolute',
                width: 'max-content',
                height: 35,
              }}
            >
              #2
            </StepNumber>
          )}
          <HowItWorksHeader>
            {t('addDetailsWithEase', { ns: 'landingPage' })}
          </HowItWorksHeader>
          <HowItWorksText>
            {t('addDetailsWithEaseDetail', { ns: 'landingPage' })}
          </HowItWorksText>
        </TextTwoWrapper>
      </HowItWorksLineOne>
      <HowItWorksLineOne
        style={{
          flexDirection: (width || 0) < 731 ? 'column-reverse' : 'row',
        }}
      >
        <CurveThree>
          <StepNumber
            style={{
              margin: 0,
              marginLeft: (width || 0) < 1561 ? '-2vw' : -30,
            }}
          >
            #3
          </StepNumber>
        </CurveThree>
        <TextTwoWrapper
          style={{
            paddingBottom: (width || 0) < 1561 ? '6.5vw' : 100,
            paddingLeft: 40,
            borderBottom: (width || 0) > 730 ? '2px dashed #7282FD' : 0,
          }}
        >
          {(width || 0) < 731 && (
            <StepNumber
              style={{
                marginLeft: -35,
                fontSize: 20,
                position: 'absolute',
                width: 'max-content',
                height: 35,
              }}
            >
              #3
            </StepNumber>
          )}
          <HowItWorksHeader>
            {t('publishwithConfidence', { ns: 'landingPage' })}
          </HowItWorksHeader>
          <HowItWorksText>
            {t('publishwithConfidenceDetail', { ns: 'landingPage' })}
          </HowItWorksText>
        </TextTwoWrapper>
        <RightImageWrapper style={{ paddingTop: 40 }}>
          <Gradient2
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              margin: 'auto',
              opacity: 0.2,
            }}
          ></Gradient2>
          <HowItWorksThree
            width={
              (width || 0) < 1561
                ? (width || 0) < 768
                  ? '230'
                  : '26vw'
                : '339'
            }
            height={(width || 0) < 768 ? '238' : '306'}
            right={(width || 0) < 1561 ? '10vw' : '100'}
            position={(width || 0) < 731 ? 'static' : 'absolute'}
          />
        </RightImageWrapper>
      </HowItWorksLineOne>
      <HowItWorksLineOne>
        <LeftImageWrapper style={{ borderBottom: 0 }}>
          <Gradient2
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              margin: 'auto',
              opacity: 0.23,
            }}
          ></Gradient2>
          <HowItWorksFour
            width={(width || 0) < 1561 ? '23vw' : '355'}
          ></HowItWorksFour>
        </LeftImageWrapper>
        <CurveTwo
          style={{
            maxHeight: 50,
            borderBottomRightRadius: 0,
            borderBottom: 0,
            marginLeft: 20,
          }}
        >
          <StepNumber
            style={{
              margin: 0,
              marginLeft: (width || 0) < 1561 ? '1.5vw' : 25,
            }}
          >
            #4
          </StepNumber>
        </CurveTwo>
        <TextTwoWrapper style={{ borderLeft: 0 }}>
          {(width || 0) < 731 && (
            <StepNumber
              style={{
                marginLeft: -35,
                fontSize: 20,
                position: 'absolute',
                width: 'max-content',
                height: 35,
              }}
            >
              #4
            </StepNumber>
          )}
          <HowItWorksHeader>
            {t('startSellingandInspire', { ns: 'landingPage' })}
          </HowItWorksHeader>
          <HowItWorksText>
            {t('startSellingandInspireDetail', { ns: 'landingPage' })}
          </HowItWorksText>
        </TextTwoWrapper>
      </HowItWorksLineOne>
    </HowItWorksWrapper>
  )
}

export default HowItWorks
